import i18n from '../../../../../../i18n';

export function formatTime(epochTime) {
    let d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(epochTime);
    return d.toLocaleString(i18n.locale);
}
